// @flow

// Effect Managers
import { call, select, takeLatest } from 'redux-saga/effects'

// Constants
import { SELECT_FARM } from '../constants'
import { PROP_HEFTY_SELECTED_FARM } from 'fc-model-environment'

// Controllers
import environmentCtrl from 'fc-ctrl-environment'

// Selectors
import { authenticatedUser$ } from 'fc-users'
import { environment$ } from 'fc-environment'

function *updateEnvironment ({ payload }: {payload: string}): Generator<*, *, *> {
  const authenticatedUser = yield select(authenticatedUser$)
  const environment = yield select(environment$)

  if (environment[PROP_HEFTY_SELECTED_FARM]) {
    yield call(environmentCtrl.update, {
      model: {
        client: authenticatedUser,
        key: PROP_HEFTY_SELECTED_FARM,
        id: environment[PROP_HEFTY_SELECTED_FARM].id,
        value: payload,
      },
    })
  } else {
    yield call(environmentCtrl.create, {
      model: {
        client: authenticatedUser,
        key: PROP_HEFTY_SELECTED_FARM,
        value: payload,
      },
    })
  }
}

export default function *watchUpdateFarm (): Generator<*, *, *> {
  yield takeLatest(SELECT_FARM, updateEnvironment)
}
